class CardColorMetaVariants extends HTMLElement {
  constructor() {
    super();

    this.hasInitialised = false;
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.productCard = this.closest('.product-card');

    this.renderCardInfo();
  }

  renderCardInfo(url = this.productUrl) {

    fetch(`${url}?section_id=main-product-card`)
      .then(response => response.text())
      .then(text => {
        
        const html = new DOMParser().parseFromString(text, "text/html");
        
        let previousReplace;

        this.elementsToRender().forEach((element) => {

          if (!element.runOnLoad && !this.hasInitialised) return;
          if (!element.runOnUpdate && this.hasInitialised) return;

          // Check if new element exists
          if (html.querySelector(element.selector) !== undefined && html.querySelector(element.selector) !== null) {

            // Check if element to be replaced exists
            if (this.productCard.querySelector(element.replace) !== undefined && this.productCard.querySelector(element.replace) !== null) {

              if (previousReplace != element.replace) {
                this.productCard.querySelector(element.replace).innerHTML = html.querySelector(element.selector).innerHTML;
              }

              if (previousReplace == element.replace) {
                this.productCard.querySelector(element.replace).innerHTML += html.querySelector(element.selector).innerHTML;
              }
            }
          }

          previousReplace = element.replace;
        });

        if (!this.hasInitialised) {

          this.runListeners();
        }

        this.hasInitialised = true;
      })
      .catch(e => {
        console.error(e);
      })
  }


  elementsToRender() {

    return [
      {
        runOnLoad: true,
        runOnUpdate: false,
        selector: "[data-main-color-swatches]",
        replace: "[data-color-meta-variants]"
      },
      {
        runOnLoad: true,
        runOnUpdate: false,
        selector: "[data-limited-edition-swatches]",
        replace: "[data-color-meta-variants]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-featured-image]",
        replace: "[data-featured-image]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-second-image]",
        replace: "[data-second-image]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-radio-variants]",
        replace: "[data-radio-variants]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-product-form]",
        replace: "[data-product-form]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-quickadd-trigger]",
        replace: "[data-quickadd-trigger]"
      },
      {
        runOnLoad: false,
        runOnUpdate: true,
        selector: "[data-slider-images]",
        replace: "[data-slider-images]"
      }
    ]
  }

  runListeners() {

    const _self = this;
    const colorSwatches = this.productCard.querySelectorAll('.color-meta-variants__options a');

    colorSwatches.forEach((colorSwatch) => {

      colorSwatch.addEventListener('click', e => {

        e.preventDefault();
        _self.renderCardInfo(colorSwatch.getAttribute("href"));

        _self.querySelector('.color-swatch.is--active').classList.remove('is--active');
        colorSwatch.querySelector('.color-swatch').classList.add('is--active');
      })
    });
  }
}

customElements.define('card-color-meta-variants', CardColorMetaVariants);